import React, { useEffect } from 'react'

export interface PropsForChartForSummary {
    data: any
    field: string
}

export const ChartForSummary = ({data, field}:PropsForChartForSummary) => {

    useEffect(() => {
        console.log({data, field})
    }, [data])
    

  return (
    <div>ChartForSummary</div>
  )
}
